import React from 'react';
import { RichTextBlock } from 'prismic-reactjs';
import Text from '@components/text';
import ContactForm, { ContactFormProps } from '@components/contact-form';
import Section from '@components/section';
import { TitleContainer, Container, StyledWrapper } from './contact-form-section.styled';

export interface ContactFormSectionProps extends ContactFormProps {
  title?: string;
  description?: RichTextBlock[];
}

const ContactFormSection = ({
  title,
  description,
  portalId,
  formId,
}: ContactFormSectionProps): JSX.Element => {
  return (
    <Section backgroundColor="white" anchorId="contact-form">
      <StyledWrapper>
        <Container>
          <TitleContainer>
            {title && <Text type="title" tag="h2" stringText={title} fontSize="heading2" />}
            {description && <Text type="subheading" richText={description} fontSize="heading4" />}
          </TitleContainer>
          {formId !== '' && <ContactForm formId={formId} portalId={portalId} />}
        </Container>
      </StyledWrapper>
    </Section>
  );
};

export default ContactFormSection;
